import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter'

function Index() {
  return (
    <DefaultLeadsPage leadType="Revolt" />
  )
}

export default Index